import { Network, RiskCurrentResponse } from '@apolloGenerated';

export class RiskCategories {
  private static categories: Partial<Record<Network, RiskCurrentResponse['params']>> = {};

  static get(network: Network) {
    return RiskCategories.categories[network];
  }

  private static set(categories: RiskCurrentResponse['params'], network: Network) {
    RiskCategories.categories[network] = categories;
  }

  static async init(
    network: Network,
    params: RiskCurrentResponse['params'],
  ): Promise<void> {
    if (RiskCategories.categories[network]) return;

    RiskCategories.set(params || {}, network);
  }
}
